import React from 'react';
import './footer.css';

function Footer() {
    return (
        <footer>
            <a href='https://www.linkedin.com/in/anthony-v-67a490214/' target='_blank' className='footer-link'>
                <i class="fa-brands fa-linkedin"></i>
            </a>
            <a href='https://github.com/hvu24' target='_blank' className='footer-link'>
                <i class="fa-brands fa-github"></i>
            </a>
        </footer>
    );
}

export default Footer;
